<template>
  <header>
    <div class="header-left">
      <div class="logo">
        <a data-v-09e78ad1 href class="m-brand__logo-wrapper">
<!--          <img data-v-09e78ad1 src="@/assets/images/storever/logo-small-white.png" />-->
        <img data-v-09e78ad1 src="https://dsmanager.storever.com/content/images/logo-auth.png" />
        </a>
      </div>
      <div>
        <i id="menu-toggler" class="fas fa-list" @click.prevent="onMenuToggle" />
      </div>
    </div>
    <div class="header-right">
      <MiniPlayer />
      <div class="breadscrum" v-if="currentStation">
        <button class="m-brand__station-toggle" v-on:click.prevent="onStationClick">
          <span class="text">{{currentStation.name}}</span>
          <span class="sep">|</span>
          <span class="text">{{getLabelName(currentStation.labelCategoryID)}}</span>
        </button>
      </div>
      <div class="actions">
        <div class="dropdownC">
          <span style="margin: 15px 20px">
              <i class="fas fa-user" :title="currentUser.email" v-if="currentUser"></i>
          </span>
          <div class="dropdownC-content">
              <router-link :to="{name:'reportUpload', params:{since: getDate() ,stationUid:this.$route.params.stationUid}}" style="color:#2b2b2b;white-space: nowrap;">
                My uploads
              </router-link><br>
            <router-link :to="{name:'multiSearchList', params:{since: getDate() ,stationUid:this.$route.params.stationUid}}" style="color:#2b2b2b;white-space: nowrap;">
              My searches
            </router-link>
          </div>
        </div>
        <a href="#" @click.prevent="handleLogout" title="Logout">
          <i class="fas fa-sign-out-alt"></i>
        </a>
      </div>
    </div>
  </header>
</template>

<script>
import Constants from "@/store/constants";
import EventBus from "@/eventbus";
import moment from "moment";
import {mapState, mapMutations, mapActions} from "vuex";
import MiniPlayer from "@/components/common/MiniPlayer";
export default {
  name: "PageHeader",
  components: { MiniPlayer },
  computed: {

    ...mapState({
      currentUser: state => state.user,
      currentStation: state => state.currentStation
    }),
    context() {
      return Constants.context;
    }
  },
  data(){
    return {
      Constants
    }
  },
  watch: {
    'currentStation': {
     async  handler(){
        if (this.currentStation && this.currentStation.name.search('MCU-') === 0  ) {
          this.isStationLock(this.currentStation.uid)

        }
      },
    },
  },
  methods: {
    getDate(){
      return moment().subtract(1, 'months').format('YYYY-MM-DD')
    },
    ...mapActions('tracks', ['isStationLock']),
    ...mapMutations(["onMenuToggle", "logout"]),
    onStationClick() {
      EventBus.$emit("displayStationsList");
    },
    handleLogout() {
      this.$store.commit("filters/cleanRules");
      // this.logout();
      this.$auth.logout({logoutParams:{returnTo: window.location.origin}});
      this.logout();
      // this.$auth.loginWithRedirect();
    }
  }
};
</script>

<style lang="scss" scoped>
#m_header_topbar {
  display: none;
}

.sep{
  padding: 0 10px;
}

.m-stack.m-stack--general {
  .m-stack__item.m-brand__left {
    display: flex;
    align-items: center;
  }

  .m-brand__logo-wrapper {
    margin-right: 20px;
  }

  .m-brand__station {
    display: flex;
  }

  .m-brand__station-toggle {
    display: flex;
    align-items: center;

    img {
      margin-right: 10px;
    }

    .text {
      position: relative;

      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -5px;
        width: 100%;
        height: 1px;
        background-color: white;
        transform: scaleX(0);
        transform-origin: 100% 50%;
        transition: transform 0.2s ease-in-out;
      }
    }

    &:hover {
      .text {
        &::after {
          transform: scaleX(1);
          transform-origin: 0 50%;
        }
      }
    }
  }
}
.dropdownC {
  position: relative;
  display: inline-block;
}

.dropdownC-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 100px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 10px 12px;
  z-index: 1;
  border-radius: 3px;
}

.dropdownC:hover .dropdownC-content {
  display: block;
}
</style>
